<template>
  <div class="animated fadeIn kanban-main-container">
    <div class="w-100 px-3 kanban-nav">
      <h5 class="pt-md-2 pt-3">
        <span class="d-md-down-none"
          ><i class="fas fa-address-card"></i> {{ boardName }} -
          <span class="text-danger">Perdidos</span>
          <i class="fas fa-grip-lines-vertical ml-4 mr-2"></i
        ></span>
        <span
          class="d-sm-block d-md-none"
          style="
            font-size: 12px;
            font-weight: 600;
            display: block;
            padding-bottom: 5px;
          "
          >{{ boardName }} - <span class="text-danger">Perdidos</span></span
        >
        <b-button
          class="btn btn-sm text-third rounded-4 d-md-down-none"
          size="sm"
          @click="onBack"
          ><i class="fas fa-arrow-circle-left"></i>&nbsp; Voltar</b-button
        >
      </h5>
      <div
        class="pt-2"
        style="position: fixed; right: 10px"
      >
        <a
          href="javascript:void(0)"
          class="pl-4 d-sm-block d-md-none"
          @click="onBack"
          ><i
            class="fas fa-arrow-circle-left f-18px text-third"
            v-b-tooltip.hover
            title="Voltar"
          ></i
        ></a>
      </div>
    </div>
    <div class="container-fluid mt-4">
      <Tables
        ref="tableGrid"
        :columns="[
          'Nome',
          'CPF/CNPJ',
          'Associado',
          'Tipo Pessoa',
          'Responsáveis',
          'Motivo Perda',
          $lang.Common.DataTable.ActionDate
        ]"
        :showReload="true"
        :showSearch="true"
        :sortOptions="sortOptions"
        v-on:Reload="onReload"
        v-on:Load="onLoad"
        v-on:Search="onShowSearch"
        v-on:Sort="onSort"
        v-on:Sort-Option-Changed="onSortOptionChange"
      >
        <tr
          v-for="obj in this.objList"
          v-bind:key="obj.id"
        >
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.inative ? 0 : 1"
            :value="
              obj.pessoa && obj.pessoa.nome ? obj.pessoa.nome.toUpperCase() : ''
            "
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.inative ? 0 : 1"
            :value="obj.pessoa ? onFormatDocument(obj.pessoa.document) : ''"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.inative ? 0 : 1"
            :value="obj.alreadyAssociate ? 'SIM' : 'NÃO'"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.inative ? 0 : 1"
            :value="obj.pessoa ? obj.pessoa.tipoPessoa : ''"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.inative ? 0 : 1"
            :value="formatReponsaveis(obj)"
          />
          <TableColumn
            :IsText="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.inative ? 0 : 1"
            :value="obj.motivo ? obj.motivo.nome : ''"
          />
          <TableColumn
            :IsDatetime="true"
            v-on:Edit="onEdit(obj)"
            :status="obj.inative ? 0 : 1"
            :value="obj.dataInicioSituacao ? obj.dataInicioSituacao : ''"
          />
        </tr>
      </Tables>
    </div>
    <ModalCard
      ref="ModalCard"
      v-if="selectedCard"
      :boardColumns="[]"
      @hideModal="closeCard"
      :key="selectedCard"
      :cardId="selectedCard"
    />
    <SidebarSearch @search="onSearch" />
  </div>
</template>
<script>
import { loading } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools.js'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'
import SidebarSearch from '../search/SidebarCard.vue'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'

export default {
  name: 'CardLost',
  mixins: [ActionsForm],
  data () {
    return {
      data: null,
      loading: true,
      board: null,
      page: 0,
      size: 10,
      totalElements: [],
      totalPages: 0,
      screenW: screen.width,
      filters: '',
      selectedCard: null,
      sortOptions: [
        {
          value: 'dataInicioSituacao,asc',
          text: 'Data de finalização (crescente)',
          icon: 'fas fa-calendar-plus forceTextThird'
        },
        {
          value: 'dataInicioSituacao,desc',
          text: 'Data de finalização (decrescente)',
          icon: 'fas fa-calendar-minus forceTextThird'
        }
      ],
      selectedSortOption: {
        value: null,
        text: null,
        icon: null
      }
    }
  },
  computed: {
    boardId: function () {
      return this.$route.params.boardId
    },
    backUrl: function () {
      return this.$route.params.backUrl
    },
    boardName () {
      let result = ''
      if (this.board) {
        result = this.board.nome
      }
      return result
    }
  },
  // mounted () {
  //   this.$eventHub.on('Filter', ({ filters }) => {
  //     this.filters = filters
  //     this.$nextTick(() => {
  //       this.onSearch(filters)
  //     })
  //   })
  // },
  components: {
    ModalCard,
    SidebarSearch
  },
  methods: {
    async onLoad () {
      this.page = 0
      await this.onLoadBoard()
      await this.onLoadCard()
      this.loading = false
    },
    async onLoadBoard () {
      if (this.boardId) {
        loading.push()
        await BoardRepository.GetById(this.boardId)
          .then((response) => {
            loading.pop()
            if (response.status === 200) {
              this.board = response.data
            }
          })
          .catch((e) => {
            loading.pop()
          })
      }
    },
    async onLoadCard () {
      let situacao = 'PERDIDO'
      const boardIsFiled = this.board.arquivado || false
      const sortOption = this.selectedSortOption.value || 'posicao'
      await CardRepository.SearchByBoard(this.boardId, boardIsFiled, situacao, this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, sortOption)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((e) => {
          loading.pop()
        })
    },
    onSort () {
      this.onLoadCard()
    },
    onSortOptionChange (sortOption) {
      this.selectedSortOption = sortOption
    },
    onReload () {
      this.onLoadCard()
    },
    onBack () {
      if (this.backUrl) {
        this.$router.push({ name: this.backUrl })
      } else {
        this.$router.push({ name: 'CRM' })
      }
    },
    onEdit (obj) {
      this.selectedCard = obj.id
    },
    closeCard () {
      this.selectedCard = null
    },
    formatReponsaveis (obj) {
      var responsaveis = []
      if (obj) {
        responsaveis = obj.responsaveis.map((data) => data.usuario.nomePessoa)
      }
      return responsaveis.join(',\n')
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onSearch (filters) {
      if (filters) {
        this.filters = Object.entries(filters)
          .filter(([key, value]) => value)
          .map(([key, value]) => `&${key}=${value}`)
          .join('')
      } else {
        this.filters = ''
      }
      this.onLoadCard()
    },
    onFormatDocument (document) {
      return Tools.formatCpfCnpj(document, Tools.checkDocumentType(document))
    }
  }
}
</script>
<style scoped>
.f-18px {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/card/lost/lostcard.vue